/**
 * view redux constants
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


// redux action IDs
export const OPEN_PAGE                      = 'OPEN_PAGE';
export const OPEN_MEDIA_OVERLAY             = 'OPEN_MEDIA_OVERLAY';
export const CLOSE_MEDIA_OVERLAY            = 'CLOSE_MEDIA_OVERLAY';
export const UPDATE_VIEW_PROPERTY           = 'UPDATE_VIEW_PROPERTY';

// page IDs
export const OBJECT_LIST_PAGE       = 'OBJECT_LIST_PAGE';
export const OBJECT_EDIT_PAGE       = 'OBJECT_EDIT_PAGE';
export const MEDIA_UPLOAD_PAGE      = 'MEDIA_UPLOAD_PAGE';
export const ANALYTICS_PAGE         = 'ANALYTICS_PAGE';
export const CONTROL_PAGE           = 'CONTROL_PAGE';
export const ADMIN_PAGE             = 'ADMIN_PAGE';
export const USER_ACCOUNT_PAGE      = 'USER_ACCOUNT_PAGE';
export const ABOUT_PAGE             = 'ABOUT_PAGE';
export const UNIKN_KUBUS_PAGE       = 'UNIKN_KUBUS_PAGE';
export const STORYTELLING_PAGE      = 'STORYTELLING_PAGE';
